import { getCornerstone, getCornerstoneTools } from "../../utils/dicomLoader";
import { emit } from "../viewerBus";
import { registerCommand } from "./registry";

// Only ruler/ROI measurements are deletable via this path. Scoping by tool name
// means a stray segmentation-contour selection — contours stay click-selectable
// while the rad is measuring — is never removed here. Measurement delete can't
// touch segmentation.
const MEASUREMENT_TOOL_NAMES = new Set(["Length", "RectangleROI"]);
const NO_SELECTION_MSG = "No measurement selected — click a measurement to clear it";

interface CsAnnotationLike {
  annotationUID?: string;
  metadata?: { toolName?: string };
}

registerCommand("deleteSelectedAnnotation", () => {
  try {
    const cs = getCornerstone();
    const csTools = getCornerstoneTools();

    // Read the LIVE selection from Cornerstone's selection manager — the single
    // source of truth. We deliberately do NOT read a mirrored jotai atom here:
    // a command reads the default jotai store, which can diverge from the
    // React-written mirror, and the mirror proved empty even when Cornerstone
    // had the annotation selected. The toolbar eraser reads live for the same
    // reason.
    const selected = Array.from(
      (csTools.annotation.selection?.getAnnotationsSelected?.() ?? []) as Iterable<string>,
    );
    if (selected.length === 0) {
      emit("toast", { message: NO_SELECTION_MSG });
      return;
    }

    const all = (csTools.annotation.state.getAllAnnotations() ?? []) as CsAnnotationLike[];
    const measurementUids = new Set(
      all
        .filter(
          (a) =>
            a.annotationUID &&
            a.metadata?.toolName &&
            MEASUREMENT_TOOL_NAMES.has(a.metadata.toolName),
        )
        .map((a) => a.annotationUID as string),
    );
    const toRemove = selected.filter((uid) => measurementUids.has(uid));
    if (toRemove.length === 0) {
      emit("toast", { message: NO_SELECTION_MSG });
      return;
    }

    toRemove.forEach((uid) => {
      csTools.annotation.state.removeAnnotation(uid);
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cs.getRenderingEngines()?.forEach((engine: any) => engine.render());
  } catch (e) {
    emit("toast", { message: "Failed to clear measurement" });
    console.warn("[deleteSelectedAnnotation] error:", e);
  }
});
